import React from "react";
import styled from "styled-components";
import {
    StandardModal,
    StandardModalActionGroup,
    StandardModalSectionTitle,
    StandardModalState
} from "src/components";

export const TierBox = styled.div`
    width: 100%;
    max-width: 100%;

    min-height: 80px;
    height: auto;

    box-shadow: 0px 5px 10px #0000001A;
    border: 1px solid #D8DEEC;
    border-radius: 15px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    opacity: 1;

    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 0 1.5rem;
    margin-top: 1rem;

    box-sizing: border-box;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        padding: 1rem;
        gap: 0.5rem;
    }
`;

export const LeftText = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 0.850rem;
`;

export const RightText = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: #8551AE;
`;


const CloseButton = styled.button`
    width: 140px;
    height: 38px;

    background: #FFFFFF;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #000;
    border-radius: 7px;

    margin-bottom: 3px;
    margin-top: 14px;
    cursor: pointer;
`;

export default function LicenseTiersModal({ show, onClose, licenseTiers = [] }) {
    if (!show) return null;

    const tiers = licenseTiers?.tiers || [];

    return (
        <StandardModal
            open={show}
            onClose={onClose}
            widthMode="large"
            title="License Tiers"
            description="This is the set of License Tiers available that are displayed to users on signup after scanning the QR code."
            footer={(
                <StandardModalActionGroup $pushRight>
                    <CloseButton onClick={onClose}>
                        Close
                    </CloseButton>
                </StandardModalActionGroup>
            )}
        >
            <StandardModalSectionTitle>
                {licenseTiers?.availableCount ?? 0} Available
            </StandardModalSectionTitle>

            {tiers.length === 0 ? (
                <StandardModalState minHeight="10rem">
                    No license tiers available.
                </StandardModalState>
            ) : (
                tiers.map((tier) => (
                    <TierBox key={tier.uuid || tier.tierName}>
                        <LeftText>
                            <div style={{ fontWeight: 700, fontSize: "16px" }}>
                                {tier.tierName} License
                            </div>
                            <div style={{ fontSize: "13px", color: "#555" }}>
                                AUD ${Number(tier.renewalCost).toFixed(2)} ({tier?.renewalPeriod})
                            </div>
                        </LeftText>

                        <RightText>
                            <div style={{ fontWeight: 600, fontSize: "16px" }}>
                                Number of Users
                            </div>
                            <div style={{ fontSize: "13px", fontWeight: 500 }}>
                                {tier.users ?? 0}
                            </div>
                        </RightText>
                    </TierBox>
                ))
            )}
        </StandardModal>
    );
}
